/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Statschartempty2Inputs */

const en_statschartempty2 = /** @type {(inputs: Statschartempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nothing has happened here in the last 14 days.`)
};

const de_statschartempty2 = /** @type {(inputs: Statschartempty2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In den letzten 14 Tagen ist hier noch nichts passiert.`)
};

/**
* | output |
* | --- |
* | "Nothing has happened here in the last 14 days." |
*
* @param {Statschartempty2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statschartempty2 = /** @type {((inputs?: Statschartempty2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statschartempty2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statschartempty2(inputs)
	return de_statschartempty2(inputs)
});
export { statschartempty2 as "statsChartEmpty" }